import type { CourseExtended, User } from 'shared-types';

interface Props {
  course: Pick<
    CourseExtended,
    | 'deadline'
    | 'deadlineDenyAccess'
    | 'disableAllAdminAnalytics'
    | 'endDate'
    | 'startDate'
  > & {
    adminAccess?: CourseExtended['adminAccess'];
    isAccessByRequest: boolean;
    isAdmin: boolean;
    isAddedUser: boolean;
    isGroupUser: boolean;
    isPathUser: boolean;
    isOwnerOrSuperadmin: boolean;
  };
  user: Pick<User, 'roles'>;
}

const getAccessStatus = ({ course, user }: Props) => {
  const data = {
    canBeOpened: false,
    canBeJoined: false,
    canBeRequested: false
  };
  if (!course) return data;

  const isPublished =
    Date.parse(course.startDate as string) < Date.now() &&
    !(Date.parse(course.endDate as string) < Date.now());

  const deniedBecauseDeadline =
    course.deadline &&
    course.deadlineDenyAccess &&
    Date.parse(course.deadline) < Date.now();

  const adminInOpenCourse =
    (course.adminAccess === 'copyable' || course.adminAccess === 'public') &&
    course.disableAllAdminAnalytics &&
    user?.roles.includes('admin');

  if (
    course.isOwnerOrSuperadmin ||
    course.isAdmin ||
    (isPublished &&
      !deniedBecauseDeadline &&
      (course.isAddedUser ||
        course.isGroupUser ||
        course.isPathUser ||
        adminInOpenCourse))
  ) {
    data.canBeOpened = true;
  }

  if (
    !data.canBeOpened &&
    !deniedBecauseDeadline &&
    isPublished &&
    (!course.isAccessByRequest ||
      (course.adminAccess &&
        ['copyable', 'public'].includes(course.adminAccess) &&
        user?.roles.includes('admin')))
  ) {
    data.canBeJoined = true;
  }

  if (
    !data.canBeJoined &&
    !deniedBecauseDeadline &&
    isPublished &&
    course.isAccessByRequest
  ) {
    data.canBeRequested = true;
  }

  return data;
};

export default getAccessStatus;
